export const DEFINE_ATUALIZACOES = 'DEFINE_ATUALIZACOES'
export const DEFINE_ERROS_ATUALIZACAO = 'DEFINE_ERROS_ATUALIZACAO'
export const DEFINE_DADOS_ATUALIZACAO = 'DEFINE_DADOS_ATUALIZACAO'